import isFunction from 'lodash/isFunction';
import useForm from '../hooks/useForm';

export default function FormProvider({ children, ...props }) {
  const { formApi, formContext, formState, render } = useForm(props);

  if (isFunction(children)) {
    return render(children({ ...formContext, formApi, formState }));
  }

  return render(children);
}
